// Colours
import { terracotta, emeraldGreen } from "Constants/ColourConstants";

export const styles = {
  centeredBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    minWidth: { xs: "18rem", sm: "60%" },
    background: "white",
    borderRadius: "2rem",
    alignItems: "center",
    gap: "1.5rem",
    py: "1.5rem",
    px: "5%",
    mt: "2rem",
    mb: "1rem",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  title: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: 20,
    color: emeraldGreen,
  },
  stepsGrid: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "10px",
    "@media (max-width: 600px)": {
      width: "auto",
      justifyContent: "center",
      flexDirection: "column",
      gap: 3,
    },
  },
  stepGrid: {
    flexDirection: "column",
    gap: 2,
    "@media (max-width: 600px)": {
      flexDirection: "row",
      gap: "1rem",
    },
  },
  iconBox: {
    height: "80px",
  },
  typographyBox: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  secondaryTitle: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "0.8rem",
    color: terracotta,
    marginTop: 1,
    "@media (max-width: 600px)": {
      textAlign: "left",
      marginTop: 0,
    },
  },
  description: {
    fontSize: "0.8rem",
    maxWidth: "10rem",
    "@media (max-width: 600px)": {
      textAlign: "left",
    },
  },
};
